import styled from "styled-components";

export const DivWithWrap = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: 2px 0;
`;

export const StyledSpan = styled.span`
    color: var(--purple-lighter);
    font-weight: bold;
    font-size: 0.82rem;
`;

export const DivIcons = styled.div`
    display: flex;
    align-items: center;
    margin: 0 4px;
    padding: 0 0 1px 0;
    border-bottom: 1px solid transparent;
`;
